import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { RiMenu4Line, RiDashboardLine } from "react-icons/ri";
import { IoClose } from "react-icons/io5";
import { TbLayersSubtract, TbReportSearch } from "react-icons/tb";
import { BiSolidOffer } from "react-icons/bi";
import { MdOutlineCategory } from "react-icons/md";
import { FaUsersGear } from "react-icons/fa6";
import { TfiWrite } from "react-icons/tfi";
import { GiStairsGoal } from "react-icons/gi";
import { SiReacthookform } from "react-icons/si";
const Sidebar = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const navigate = useNavigate();
  const path = useLocation();

  // const userData = JSON.parse(localStorage.getItem("carRental-userData"));
  // const permissions = userData?.permissions || {};

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Define menu items with corresponding permissions
  const menuItems = [
    { label: "Dashboard", icon: <RiDashboardLine size={18} />, path: "/dashboard", permission: "dashboard" },
    { label: "Inquiry", icon: <TbReportSearch size={18} />, path: "/inquiry-form", permission: "inquiry-form" },
    { label: "Packages", icon: <BiSolidOffer size={18} />, path: "/auth-packages", permission: "package" },
    { label: "category", icon: <MdOutlineCategory size={18} />, path: "/auth-category", permission: "category" },
    { label: "subcategory", icon: <TbLayersSubtract size={18} />, path: "/auth-subcategory", permission: "subcategory" },
    { label: "Service", icon: <FaUsersGear size={18} />, path: "/auth-service", permission: "service" },
    { label: "Blog", icon: <TfiWrite size={18} />, path: "/auth-blog", permission: "blog" },
    { label: "Career", icon: <GiStairsGoal size={18} />, path: "/auth-career", permission: "career" },
    { label: "Form Data", icon: <SiReacthookform  size={18} />, path: "/career-form", permission: "career-form" },
  ];

  // Filter menu items based on permissions
  // const filteredMenuItems = menuItems.filter((item) => permissions[item.permission]);

  const renderMenuItems = () => (
    <ul className="space-y-1 tracking-wide">
      {menuItems.map((item) => (
        <li key={item.path}>
          <div
            onClick={() => navigate(item.path)}
            className={`${path.pathname === item.path
              ? "bg-[#069ab7] text-white font-medium"
              : "text-primaryTextColor font-normal hover:bg-[#4dd0eb]"
              } flex items-center cursor-pointer p-2 text-base rounded-lg mt-3`}
          >
            {item.icon}
            <span className="ml-3 tracking-wide">{item.label}</span>
          </div>
        </li>
      ))}
    </ul>
  );

  return (
    <React.Fragment>
      {/* Large sidebar */}
      <div className="lg:contents hidden flex-shrink-0" aria-label="Sidebar">
        <div className="overflow-y-auto pb-2 px-3 pt-6 shadow-2xl h-screen">
          {renderMenuItems()}
        </div>
      </div>

      {/* Mobile sidebar */}
      <div className="block lg:hidden">
        <button
          onClick={toggleSidebar}
          className="absolute ml-6 mt-[-50px] text-[#FFFFFF] "
        >
          {isSidebarOpen ? <IoClose size={30} /> : <RiMenu4Line size={30} />}
        </button>
        <AnimatePresence>
          {isSidebarOpen && (
            <motion.div
              className="h-full w-[50%] absolute z-50 shadow-2xl"
              initial={{ opacity: 0, x: "-100%" }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: "-100%" }}
              transition={{ duration: 0.3 }}
            >
              <div className="overflow-y-auto py-4 px-3  h-screen relative bg-white z-20">
                {renderMenuItems()}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </React.Fragment>
  );
};

export default Sidebar;